import { SVGProps } from 'react';

const Add = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.625 7.14h-6.77L4.416 11.66h14.946l.387 1.004V21.7h-2.875v-2.008h-11.5V21.7H2.5v-9.037l2.329-7.03h7.796zm-6.887 6.805c-.796 0-1.438.673-1.438 1.507s.642 1.506 1.438 1.506 1.437-.673 1.437-1.506c0-.834-.642-1.507-1.437-1.507m10.541-.245c-.795 0-1.437.673-1.437 1.507s.642 1.506 1.437 1.506c.796 0 1.438-.673 1.438-1.506 0-.834-.642-1.507-1.438-1.507"
      clipRule="evenodd"
    />
    <path fill="currentColor" d="M21.7 5.4v2h-3v3h-2v-3h-3v-2h3v-3h2v3z" />
  </svg>
);
export default Add;
